export function setDefaultLoginState() {
	$("#bank-id-qr-image").hide();
	$(".bank-id-status").hide();
	$("#bank-id-log-in").show();
	$("#go-back-button").hide();
	$("#bank-id-cancel-qr-button").hide();
	$("#bank-id-qr-try-again").hide();
	$(".js-choice-container").show();
	$(".js-bottom-group").show();
	$("#tab-password").removeClass("selected");
	$("#password-button").removeClass("selected");
	$("#error-box").addClass("hidden");
}

export function setDefaultActivationState() {
	$("#bank-id-qr-image").addClass("hidden");
	$(".bank-id-status").hide();
	$("#bank-id-log-in").show();
	$("#go-back-button").show();
	$("#bank-id-cancel-qr-button").hide();
	$("#bank-id-qr-try-again").hide();
}

export function setBankIdQrState() {
	$("#bank-id-log-in").hide();
	$("#bank-id-qr-image").show();
	$("#bank-id-qr-status").show();
	$("#tab-qr").addClass("selected");
	$("#bank-id-cancel-qr-button").show();
	$("#go-back-button").hide();
	$("#bank-id-qr-try-again").hide();
	$("#bank-id-same-device-container").hide();
}

export function setBankIdSameDeviceState() {
	$("#spinner").removeClass("hidden");
	$("#bank-id-other-device").show();
	$("#bank-id-same-device-status").show();
}

export function setFailureToActivateState() {
	$("#spinner").addClass("hidden");
	$(".bank-id-status p").text(
		"Aktiveringen misslyckades. Gå tillbaka och försök igen eller prova en annan inloggningsmetod!"
	);
}

export function setFailedPollStatusState() {
	$("#bank-id-qr-image").hide();
	$("#spinner").addClass("hidden");
	$("#bank-id-qr-try-again").hide();
}
